export default {
    ADMIN:'Administrador(a)',
    ESTUDIANTE:'Estudiante',
    oficialAdmisiones:"Oficial de admisiones",
    DIRECTOR:"Director",
    REGISTRO:"Registro",
    REPORTERIA:"Reporteria",
    ADMINISTRADOR_DE_CONFIGURACIONES:"Admin de configuraciones"
};